export const pathConfig = {
  staticsPath: "",
};
